import template from './socialSecurity.html';
import './socialSecurity.scss';
import controller from './socialSecurity.controller';

let socialSecurity = {
  restrict: 'E',
  bindings: {},
  controller,
  template,
};

export default socialSecurity;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurity.component.js